import { jsx as n } from "react/jsx-runtime";
import x, { useState as C, useRef as J, createElement as K, Fragment as L, useEffect as d } from "react";
import { u as N } from "./index-6a632112.mjs";
import { TextInput as g } from "./textInput.js";
import { D as i, a as Q } from "./index-39f84169.mjs";
import { u as U } from "./uniqueId-321287e8.mjs";
import "./themes-5f0b3c3d.mjs";
import "./lineHeights-72d3110c.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "./label-3b996c7d.mjs";
import "./tooltip.js";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./button.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./helperText-698f3ed9.mjs";
import "./warningFilled-691cfde1.mjs";
import "./radio.js";
import "./checkbox.js";
import "./checkmark-84b5274e.mjs";
import "./subtract-848336fd.mjs";
import "./menu.js";
import "./moreVertical-dc2e97a2.mjs";
const T = N.div`
  width: 100%;
`, W = (m, l) => {
  let p = m.trim();
  return p = p?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), l.filter(
    (o) => `${o.label}${o.value}`.search(new RegExp(p, "i")) >= 0
  ).map((o) => o.value);
}, b = ({ ...m }) => /* @__PURE__ */ n(Q, { ...m }), f = ({
  children: m,
  uniqueIdentifier: l,
  onChange: p,
  type: o = "default",
  searchHandler: D = null,
  menuHeader: I = "default",
  isDisabled: y = !1,
  menuDirection: R = "down_left",
  searchValue: u = "",
  closeOnSelect: k = !1,
  menuToggleSubscriber: M,
  loadDefaultOptions: O = 0,
  onBlur: B,
  maxItems: P = 8,
  className: j,
  exceedOverflow: A = !1
}) => {
  const [s, w] = C(!1), [c, a] = C(""), [E, S] = C([]), [F, z] = C([]), v = J(U("dd")), h = [];
  let _ = !1;
  const G = x.Children.map(m, (e, t) => {
    if (e && x.isValidElement(e)) {
      if (e.type === b) {
        const r = e.props;
        return h.push({
          value: r.value,
          label: r.label,
          description: r.description,
          key: r.value
        }), /* @__PURE__ */ n(
          i.Item,
          {
            ...r,
            isSelected: E.length > 0 ? E.map(($) => $.value).includes(r?.value) : r?.isSelected || !1
          },
          t
        );
      } else if (e.type === T) {
        const r = e.props;
        return r?.render ? /* @__PURE__ */ n(i.Control, { children: r?.render({
          id: `control-${l || v.current}`,
          ariaControls: `list-${l || v.current}`,
          ariaHasPopup: "listbox",
          ariaExpanded: s,
          ariaActivedescendant: ""
        }) }, t) : /* @__PURE__ */ K(i.Control, { ...r, key: t });
      } else if (e.type === g) {
        const r = e.props;
        return _ = !0, /* @__PURE__ */ n(i.Control, { children: /* @__PURE__ */ n(
          g,
          {
            ...r,
            id: `control-${l || v.current}`,
            value: c,
            onChange: ($) => {
              s || w(!0), a($.target.value);
            }
          }
        ) }, t);
      } else if (c.trim().length === 0)
        return /* @__PURE__ */ n(L, { children: e }, t);
    }
  });
  d(() => {
    M && M(s), a(s || o === "multiple" ? "" : E[0]?.label || "");
  }, [s]), d(() => {
    u && a(u);
  }, [u]), d(() => {
    a(u);
  }, [u]), d(() => {
    let e = [];
    D ? e = D(c, h) : e = W(c, h), z(
      h.filter((t) => !e.includes(t.value)).map((t) => t.value)
    );
  }, [c]), d(() => {
    O < 0 && w(!0), S([]);
  }, [O]);
  const H = (e, t) => {
    p && p(e, t), S(o === "multiple" ? t : [t]);
  };
  return /* @__PURE__ */ n(
    i,
    {
      className: j,
      menuOpen: s,
      handleMenuOpen: (e) => w(e),
      isDisabled: y,
      menuDirection: R,
      exceedOverflow: A,
      maxItems: P,
      uniqueIdentifier: l || v.current,
      type: o,
      closeOnSelect: k,
      onBlur: B,
      onChange: H,
      hiddenItems: F,
      menuHeader: I && I !== "local_search" ? I : _ && "default" || "local_search",
      children: G
    }
  );
};
f.Control = T;
f.ControlInput = g;
f.Item = b;
f.Divider = i.Divider;
f.Title = i.Title;
export {
  f as DropdownMenu
};
